/* Mondō London - Lenis-driven Archive Cover Flow. */
(function () {
  'use strict';

  var MIN_SCROLL_STEP = 240;
  var MAX_SCROLL_STEP = 300;
  var SCROLL_STEP_RATIO = .38;
  var FAST_SCROLL_VELOCITY_RATIO = .12;
  var FAST_SCROLL_LAG_RATIO = 1.25;
  var VERTICAL_SETTLE_DELAY = 180;
  var RENDER_RANGE = 4;
  var PREVIEW_CACHE_LIMIT = 10;
  var MAX_PREVIEW_REQUESTS = 4;
  var PREVIEW_QUEUE_LIMIT = 12;
  var ACTIVE_IMAGE_RETRY_DELAY = 900;
  var ANNOUNCE_DELAY = 180;
  var SIDE_IMAGE_SIZES = '(min-width: 900px) 240px, 82vw';
  var ACTIVE_IMAGE_SIZES = '(min-width: 1600px) 600px, (min-width: 1200px) 50vw, (min-width: 900px) 46vw, 82vw';

  function getArchiveMotionFrame(scroll, journeyStart, scrollStep, slideCount, activeIndex, velocity, targetScroll, velocityRatio, lagRatio) {
    var lastIndex = Math.max(0, slideCount - 1);
    var rawPosition = scrollStep > 0 ? (scroll - journeyStart) / scrollStep : 0;
    var position = Math.max(0, Math.min(rawPosition, lastIndex));
    var index = Math.max(0, Math.min(Math.round(position), lastIndex));
    var jumpDistance = Math.abs(index - activeIndex);
    var speed = Math.abs(Number(velocity) || 0);
    var target = Number.isFinite(targetScroll) ? targetScroll : scroll;
    var lag = Math.abs(target - scroll);
    return {
      position: position,
      index: index,
      jumpDistance: jumpDistance,
      deferImages: jumpDistance > 1 || speed > scrollStep * velocityRatio || lag > scrollStep * lagRatio
    };
  }

  function getArchivePlaneFrame(index, flowPosition, imageRatios, planeHeight, sideStep) {
    var lastIndex = Math.max(0, imageRatios.length - 1);
    var position = Math.max(0, Math.min(flowPosition, lastIndex));
    var lower = Math.floor(position);
    var upper = Math.min(lastIndex, lower + 1);
    var mix = position - lower;
    var centreRatio = imageRatios[lower] + ((imageRatios[upper] - imageRatios[lower]) * mix);
    var centreWidth = planeHeight * centreRatio;
    var distance = index - flowPosition;
    var absolute = Math.abs(distance);
    var direction = distance < 0 ? -1 : distance > 0 ? 1 : 0;
    var fold = Math.min(1, absolute);
    var excess = Math.max(0, absolute - 1);
    var planeWidth = planeHeight * imageRatios[index];
    var firstOffset = ((centreWidth + planeWidth) / 2) + 8;

    return {
      x: direction * ((firstOffset * fold) + (excess * sideStep)),
      z: 100 - (400 * fold) - (36 * excess),
      rotate: direction * -64 * fold,
      scale: Math.max(.68, 1 - (.26 * fold) - (.02 * excess)),
      origin: 50 - (direction * 50 * fold),
      zIndex: Math.round(2000 - (1000 * fold) - excess)
    };
  }

  function archiveEaseOut(progress) {
    return 1 - Math.pow(1 - progress, 3);
  }

  function getArchivePointerIntent(deltaX, deltaY) {
    var distanceX = Math.abs(deltaX);
    var distanceY = Math.abs(deltaY);
    if (Math.max(distanceX, distanceY) < 8) return 'pending';
    if (distanceX >= distanceY * 1.35) return 'horizontal';
    if (distanceY >= distanceX * 1.35) return 'vertical';
    return 'pending';
  }

  function isArchiveProgrammaticSource(source) {
    return typeof source === 'string' && source.indexOf('archive-coverflow') === 0;
  }

  function getArchiveScrubPosition(value, slideCount) {
    var lastIndex = Math.max(0, slideCount - 1);
    var numericValue = Number(value);
    if (!Number.isFinite(numericValue)) numericValue = 1;
    return Math.max(0, Math.min(numericValue - 1, lastIndex));
  }

  function getArchiveScrubValue(position, slideCount) {
    var lastIndex = Math.max(0, slideCount - 1);
    var numericPosition = Number(position);
    if (!Number.isFinite(numericPosition)) numericPosition = 0;
    return Math.max(0, Math.min(numericPosition, lastIndex)) + 1;
  }

  function getArchiveScrubberKeyTarget(currentIndex, key, slideCount) {
    var lastIndex = Math.max(0, slideCount - 1);
    var targetIndex = null;
    if (key === 'ArrowLeft' || key === 'ArrowDown') targetIndex = currentIndex - 1;
    else if (key === 'ArrowRight' || key === 'ArrowUp') targetIndex = currentIndex + 1;
    else if (key === 'PageDown') targetIndex = currentIndex - 10;
    else if (key === 'PageUp') targetIndex = currentIndex + 10;
    else if (key === 'Home') targetIndex = 0;
    else if (key === 'End') targetIndex = lastIndex;
    if (targetIndex === null) return null;
    return Math.max(0, Math.min(targetIndex, lastIndex));
  }

  function getArchiveScrubPointerPosition(clientX, railLeft, railWidth, slideCount) {
    var lastIndex = Math.max(0, slideCount - 1);
    var width = Number(railWidth);
    if (!Number.isFinite(width) || width <= 0) return 0;
    var ratio = (Number(clientX) - Number(railLeft)) / width;
    if (!Number.isFinite(ratio)) ratio = 0;
    return Math.max(0, Math.min(ratio, 1)) * lastIndex;
  }

  function getArchiveTapDirection(clientX, viewportLeft, viewportWidth) {
    var width = Number(viewportWidth);
    if (!Number.isFinite(width) || width <= 0) return 0;
    var ratio = (Number(clientX) - Number(viewportLeft)) / width;
    if (!Number.isFinite(ratio)) return 0;
    if (ratio < .45) return -1;
    if (ratio > .55) return 1;
    return 0;
  }

  function getArchiveCarouselKeyTarget(currentIndex, key, slideCount) {
    var lastIndex = Math.max(0, slideCount - 1);
    var targetIndex = null;
    if (key === 'ArrowLeft') targetIndex = currentIndex - 1;
    else if (key === 'ArrowRight') targetIndex = currentIndex + 1;
    else if (key === 'Home') targetIndex = 0;
    else if (key === 'End') targetIndex = lastIndex;
    if (targetIndex === null) return null;
    return Math.max(0, Math.min(targetIndex, lastIndex));
  }

  function initArchive(root) {
    if (!root || root._archiveDestroy) return;

    var carousel = root.querySelector('[data-archive-carousel]');
    var pin = root.querySelector('[data-archive-pin]');
    var viewport = root.querySelector('[data-archive-viewport]');
    var track = root.querySelector('[data-archive-track]');
    if (!carousel || !pin || !viewport || !track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-archive-slide]'));
    var cards = Array.prototype.slice.call(track.querySelectorAll('[data-archive-card]'));
    var planes = Array.prototype.slice.call(track.querySelectorAll('[data-archive-plane]'));
    var summaries = planes;
    if (!slides.length || cards.length !== slides.length || planes.length !== slides.length) return;

    var images = cards.map(function (card) { return card.querySelector('.archive-drawer__media img'); });
    var imageRatios = slides.map(function (slide) {
      var ratio = parseFloat(slide.getAttribute('data-archive-aspect-ratio'));
      return Number.isFinite(ratio) ? Math.max(.45, Math.min(1.25, ratio)) : .75;
    });
    var widestImageRatio = Math.max.apply(Math, imageRatios);
    var recordLinks = cards.map(function (card) { return card.querySelector('.archive-drawer__record'); });
    var previous = root.querySelector('[data-archive-prev]');
    var next = root.querySelector('[data-archive-next]');
    var topButton = root.querySelector('[data-archive-top]');
    var scrubber = root.querySelector('[data-archive-scrubber]');
    var scrubberInput = scrubber && scrubber.querySelector('[data-archive-scrub]');
    var position = root.querySelector('[data-archive-position]');
    var status = root.querySelector('[data-archive-status]');
    var activeMetadata = root.querySelector('[data-archive-active-metadata]');
    var activeMetadataMaker = activeMetadata && activeMetadata.querySelector('[data-archive-active-maker]');
    var activeMetadataTitle = activeMetadata && activeMetadata.querySelector('[data-archive-active-title]');
    var activeMetadataSeason = activeMetadata && activeMetadata.querySelector('[data-archive-active-season]');
    var activeMetadataLine = activeMetadata && activeMetadata.querySelector('[data-archive-active-line]');
    var activeMetadataType = activeMetadata && activeMetadata.querySelector('[data-archive-active-type]');
    var activeMetadataLink = activeMetadata && activeMetadata.querySelector('[data-archive-active-link]');
    var makerLinks = Array.prototype.slice.call(root.querySelectorAll('[data-archive-maker-link]'));
    var archiveTitleId = carousel.getAttribute('aria-labelledby');
    var archiveTitle = archiveTitleId ? document.getElementById(archiveTitleId) : null;
    var lenis = window.lenis || null;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var desktopMode = window.matchMedia('(min-width: 900px)');
    var mobileCatalogue = window.matchMedia('(max-width: 899px), (orientation: portrait) and (any-pointer: coarse), (max-height: 699px) and (any-pointer: coarse)');
    var touchCoverflow = window.matchMedia('(min-width: 900px) and (min-height: 700px) and (orientation: landscape) and (any-pointer: coarse)');
    var originalRoleDescription = carousel.getAttribute('aria-roledescription');
    var controller = new AbortController();
    var signal = controller.signal;
    var activeIndex = cards.findIndex(function (card) { return card.open; });
    var flowPosition = 0;
    var verticalMode = false;
    var touchCoverflowMode = false;
    var touchPointerId = null;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartFlowPosition = 0;
    var touchGestureIntent = 'idle';
    var touchDragging = false;
    var touchSuppressClick = false;
    var touchSettleTimer = null;
    var touchClickTimer = null;
    var scrubberDragging = false;
    var scrubberPointerId = null;
    var scrubberKeyTarget = null;
    var archiveKeyTarget = null;
    var updating = false;
    var journeyStart = 0;
    var scrollStep = MIN_SCROLL_STEP;
    var horizontalTargets = [];
    var horizontalHandledIndex = -1;
    var renderedIndices = [];
    var coverflowMetrics = null;
    var settleTimer = null;
    var verticalSettleTimer = null;
    var announceTimer = null;
    var imageRetryTimer = null;
    var resizeObserver = null;
    var unsubscribeLenis = null;
    var imageToken = 0;
    var committedImageIndex = 0;
    var retainedImageIndex = -1;
    var deferImageWork = false;
    var destroyed = false;
    var supportsScrollEnd = 'onscrollend' in viewport;

    if (activeIndex < 0) activeIndex = 0;
    flowPosition = activeIndex;
    committedImageIndex = activeIndex;

    var originalImages = images.map(function (image) {
      if (!image) return null;
      return {
        src: image.getAttribute('src') || '',
        srcset: image.getAttribute('srcset') || '',
        sizes: image.getAttribute('sizes') || '',
        loading: image.getAttribute('loading') || 'lazy',
        fetchpriority: image.getAttribute('fetchpriority') || ''
      };
    });
    var previewSources = slides.map(function (slide) {
      return slide.getAttribute('data-archive-preview-src') || '';
    });
    var previewCache = new Array(slides.length);
    var previewOrder = [];
    var previewQueue = [];
    var previewInFlight = 0;

    function clampIndex(index) {
      return Math.max(0, Math.min(index, slides.length - 1));
    }

    function currentScroll() {
      return lenis ? lenis.scroll : window.scrollY;
    }

    function headerHeight() {
      var header = document.querySelector('.site-header');
      if (header) return header.offsetHeight;
      return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--gbar-h')) || 0;
    }

    function scrubberValueText(index) {
      var title = cards[index].getAttribute('data-archive-title') || '';
      var vendor = cards[index].getAttribute('data-archive-vendor') || '';
      var identity = [vendor, title].filter(Boolean).join(', ');
      return 'Record ' + (index + 1) + ' of ' + slides.length + (identity ? ': ' + identity : '');
    }

    function syncScrubber(nextFlowPosition) {
      if (!scrubberInput) return;
      var scrubValue = getArchiveScrubValue(nextFlowPosition, slides.length);
      var candidateIndex = clampIndex(Math.round(scrubValue - 1));
      var progress = slides.length > 1 ? ((scrubValue - 1) / (slides.length - 1)) * 100 : 0;
      scrubberInput.value = scrubValue.toFixed(4);
      scrubberInput.style.setProperty('--archive-scrub-progress', progress.toFixed(3) + '%');
      scrubberInput.setAttribute('aria-valuetext', scrubberValueText(candidateIndex));
    }

    function horizontalFlowPosition() {
      if (horizontalTargets.length !== slides.length) measureHorizontal();
      if (horizontalTargets.length < 2) return 0;
      var scrollLeft = viewport.scrollLeft;
      if (scrollLeft <= horizontalTargets[0]) return 0;
      for (var index = 1; index < horizontalTargets.length; index += 1) {
        if (scrollLeft <= horizontalTargets[index]) {
          var span = horizontalTargets[index] - horizontalTargets[index - 1];
          var mix = span > 0 ? (scrollLeft - horizontalTargets[index - 1]) / span : 0;
          return (index - 1) + Math.max(0, Math.min(mix, 1));
        }
      }
      return slides.length - 1;
    }

    function beginScrubber(event) {
      if (!scrubberInput || scrubberInput.disabled || mobileCatalogue.matches) return;
      if (event && typeof event.isPrimary === 'boolean' && !event.isPrimary) return;
      archiveKeyTarget = null;
      scrubberKeyTarget = null;
      scrubberDragging = true;
      carousel.setAttribute('data-archive-scrubbing', '');
      carousel.removeAttribute('data-archive-touch-settling');
      window.clearTimeout(settleTimer);
      settleTimer = null;
      window.clearTimeout(verticalSettleTimer);
      verticalSettleTimer = null;
      setImageDeferral(true);
    }

    function previewScrubber() {
      if (!scrubberInput || scrubberInput.disabled || mobileCatalogue.matches) return;
      if (!scrubberDragging) beginScrubber();
      flowPosition = getArchiveScrubPosition(scrubberInput.value, slides.length);
      var candidateIndex = clampIndex(Math.round(flowPosition));
      syncScrubber(flowPosition);

      if (verticalMode) {
        renderCoverflow();
        if (candidateIndex !== activeIndex) {
          setActive(candidateIndex, { announce: false, transient: true, skipRender: true });
        }
        if (lenis && !touchCoverflowMode) {
          lenis.scrollTo(journeyStart + (flowPosition * scrollStep), {
            immediate: true,
            force: true,
            userData: { source: 'archive-coverflow-scrub' }
          });
        }
        return;
      }

      if (horizontalTargets.length !== slides.length) measureHorizontal();
      var lower = Math.floor(flowPosition);
      var upper = Math.min(slides.length - 1, lower + 1);
      var mix = flowPosition - lower;
      viewport.scrollLeft = horizontalTargets[lower] + ((horizontalTargets[upper] - horizontalTargets[lower]) * mix);
    }

    function settleScrubber() {
      if (!scrubberDragging || !scrubberInput || scrubberInput.disabled) return;
      scrubberDragging = false;
      scrubberKeyTarget = null;
      carousel.removeAttribute('data-archive-scrubbing');
      setImageDeferral(false);
      var targetIndex = clampIndex(Math.round(getArchiveScrubPosition(scrubberInput.value, slides.length)));
      if (!verticalMode) {
        horizontalHandledIndex = targetIndex;
        setActive(targetIndex, { announce: false, force: true });
      }
      goTo(targetIndex, {
        announce: false,
        immediate: !verticalMode && reducedMotion.matches,
        source: 'archive-coverflow-scrub'
      });
    }

    function updateScrubberFromPointer(event) {
      if (!scrubberInput || !event) return;
      var rect = scrubberInput.getBoundingClientRect();
      var nextPosition = getArchiveScrubPointerPosition(event.clientX, rect.left, rect.width, slides.length);
      scrubberInput.value = getArchiveScrubValue(nextPosition, slides.length).toFixed(4);
      previewScrubber();
    }

    function onScrubberPointerDown(event) {
      beginScrubber(event);
      if (!scrubberDragging || event.pointerType === 'mouse') return;
      if (scrubberPointerId !== null) return;
      scrubberPointerId = event.pointerId;
      event.preventDefault();
      try { scrubberInput.setPointerCapture(event.pointerId); } catch (error) {}
      updateScrubberFromPointer(event);
    }

    function onScrubberPointerMove(event) {
      if (scrubberPointerId === null || event.pointerId !== scrubberPointerId) return;
      event.preventDefault();
      updateScrubberFromPointer(event);
    }

    function finishScrubberPointer(event) {
      if (scrubberPointerId === null) {
        if (!event || event.pointerType === 'mouse') settleScrubber();
        return;
      }
      if (event && event.pointerId !== scrubberPointerId) return;
      var pointerId = scrubberPointerId;
      scrubberPointerId = null;
      if (scrubberInput.hasPointerCapture && scrubberInput.hasPointerCapture(pointerId)) {
        try { scrubberInput.releasePointerCapture(pointerId); } catch (error) {}
      }
      settleScrubber();
    }

    function onScrubberKeydown(event) {
      if (!scrubberInput || scrubberInput.disabled) return;
      var currentIndex = scrubberKeyTarget === null
        ? clampIndex(Math.round(getArchiveScrubPosition(scrubberInput.value, slides.length)))
        : scrubberKeyTarget;
      var targetIndex = getArchiveScrubberKeyTarget(currentIndex, event.key, slides.length);
      if (targetIndex === null) return;

      event.preventDefault();
      scrubberDragging = false;
      carousel.removeAttribute('data-archive-scrubbing');
      setImageDeferral(false);
      scrubberKeyTarget = targetIndex;
      flowPosition = targetIndex;
      syncScrubber(flowPosition);
      if (!verticalMode) {
        horizontalHandledIndex = targetIndex;
        setActive(targetIndex, { announce: true, force: true });
      }
      goTo(targetIndex, {
        announce: true,
        immediate: event.key === 'Home' || event.key === 'End',
        source: 'archive-coverflow-scrub-keyboard'
      });
    }

    function endScrubberKeyboard() {
      scrubberKeyTarget = null;
    }

    function setScrubberAvailability(enabled) {
      if (!scrubber || !scrubberInput) return;
      if (!enabled) {
        scrubberDragging = false;
        scrubberKeyTarget = null;
        carousel.removeAttribute('data-archive-scrubbing');
      }
      scrubber.hidden = !enabled;
      scrubberInput.disabled = !enabled;
      if (enabled) syncScrubber(flowPosition);
    }

    function updateControls() {
      if (previous) previous.disabled = activeIndex <= 0;
      if (next) next.disabled = activeIndex >= slides.length - 1;
      if (position) position.textContent = (activeIndex + 1) + ' / ' + slides.length;
    }

    function updateMakerLinks() {
      var maker = slides[activeIndex].getAttribute('data-archive-maker');
      makerLinks.forEach(function (link) {
        var current = link.getAttribute('href') === '#archive-maker-' + maker;
        link.classList.toggle('is-current', current);
        if (current) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }

    function updateMetadataField(field, value) {
      if (!field) return;
      var target = field.querySelector('em') || field;
      target.textContent = value || '';
      field.hidden = !value;
    }

    function updateActiveMetadata(index) {
      if (!activeMetadata || !cards[index] || !recordLinks[index]) return;
      var card = cards[index];
      var slide = slides[index];
      activeMetadataMaker.textContent = card.getAttribute('data-archive-vendor') || '';
      activeMetadataTitle.textContent = card.getAttribute('data-archive-title') || '';
      updateMetadataField(activeMetadataSeason, slide.getAttribute('data-archive-season') || '');
      updateMetadataField(activeMetadataLine, slide.getAttribute('data-archive-line') || '');
      updateMetadataField(activeMetadataType, slide.getAttribute('data-archive-type') || '');
      activeMetadataLink.setAttribute('href', recordLinks[index].getAttribute('href') || '#');
    }

    function updateStatus(announce) {
      if (!status) return;
      var title = cards[activeIndex].getAttribute('data-archive-title') || '';
      var vendor = cards[activeIndex].getAttribute('data-archive-vendor') || '';
      status.setAttribute('aria-live', announce ? 'polite' : 'off');
      status.textContent = 'Record ' + (activeIndex + 1) + ' of ' + slides.length + ': ' + vendor + ', ' + title;
    }

    function scheduleAnnouncement() {
      window.clearTimeout(announceTimer);
      announceTimer = window.setTimeout(function () {
        announceTimer = null;
        updateStatus(true);
      }, ANNOUNCE_DELAY);
    }

    function removePreviewOrder(index) {
      var orderIndex = previewOrder.indexOf(index);
      if (orderIndex >= 0) previewOrder.splice(orderIndex, 1);
    }

    function touchPreview(index) {
      removePreviewOrder(index);
      previewOrder.push(index);
    }

    function removeQueuedPreview(entry) {
      var queueIndex = previewQueue.indexOf(entry);
      if (queueIndex >= 0) previewQueue.splice(queueIndex, 1);
    }

    function settlePreview(entry, result) {
      if (!entry || entry.settled) return;
      entry.settled = true;
      var resolve = entry.resolve;
      entry.resolve = null;
      if (resolve) resolve(result);
    }

    function releasePreview(entry, cancelSource) {
      if (!entry || !entry.preview) return;
      entry.preview.onload = null;
      entry.preview.onerror = null;
      if (cancelSource) entry.preview.removeAttribute('src');
      entry.preview = null;
    }

    function deleteReadyPreview(index) {
      var entry = previewCache[index];
      releasePreview(entry, false);
      previewCache[index] = null;
      removePreviewOrder(index);
    }

    function trimPreviewCache() {
      var ready = previewOrder.filter(function (index) {
        return previewCache[index] && previewCache[index].status === 'ready';
      });
      while (ready.length > PREVIEW_CACHE_LIMIT) {
        deleteReadyPreview(ready.shift());
      }
    }

    function pumpPreviewQueue() {
      if (destroyed) return;
      while (previewInFlight < MAX_PREVIEW_REQUESTS && previewQueue.length) {
        var highIndex = previewQueue.findIndex(function (entry) { return entry.priority === 'high'; });
        var entry = previewQueue.splice(highIndex >= 0 ? highIndex : 0, 1)[0];
        if (!entry || entry.status !== 'queued' || previewCache[entry.index] !== entry) continue;
        startPreview(entry);
      }
    }

    function finishPreview(entry, ready) {
      if (!entry || entry.status !== 'loading') return;
      var preview = entry.preview;
      previewInFlight = Math.max(0, previewInFlight - 1);
      entry.status = ready ? 'ready' : 'error';
      if (ready && preview) entry.src = preview.currentSrc || entry.source;
      releasePreview(entry, false);
      if (ready) {
        touchPreview(entry.index);
        trimPreviewCache();
      } else {
        previewCache[entry.index] = null;
        removePreviewOrder(entry.index);
      }
      settlePreview(entry, ready ? entry : null);
      pumpPreviewQueue();
    }

    function startPreview(entry) {
      if (!entry || entry.status !== 'queued' || destroyed) return;
      var preview = new Image();
      entry.status = 'loading';
      entry.preview = preview;
      previewInFlight += 1;
      preview.decoding = 'async';
      preview.fetchPriority = entry.priority;
      preview.onload = function () {
        if (typeof preview.decode === 'function') {
          preview.decode().then(function () { finishPreview(entry, true); }).catch(function () { finishPreview(entry, true); });
        } else {
          finishPreview(entry, true);
        }
      };
      preview.onerror = function () { finishPreview(entry, false); };
      preview.src = entry.source;
    }

    function cancelPreview(index, shouldPump) {
      var entry = previewCache[index];
      if (!entry) return;
      removeQueuedPreview(entry);
      if (entry.status === 'loading') previewInFlight = Math.max(0, previewInFlight - 1);
      entry.status = 'cancelled';
      releasePreview(entry, true);
      previewCache[index] = null;
      removePreviewOrder(index);
      settlePreview(entry, null);
      if (shouldPump !== false) pumpPreviewQueue();
    }

    function findPreemptablePreview(requestedIndex) {
      var fallback = null;
      for (var orderIndex = 0; orderIndex < previewOrder.length; orderIndex += 1) {
        var index = previewOrder[orderIndex];
        var entry = previewCache[index];
        if (!entry || entry.status !== 'loading' || index === requestedIndex || index === activeIndex) continue;
        if (entry.priority !== 'high') return entry;
        if (!fallback) fallback = entry;
      }
      return fallback;
    }

    function prioritisePreview(entry, urgent) {
      if (!entry || entry.status === 'ready') return;
      entry.priority = 'high';
      if (entry.preview) entry.preview.fetchPriority = 'high';
      if (entry.status === 'queued') {
        removeQueuedPreview(entry);
        previewQueue.unshift(entry);
        if (urgent && previewInFlight >= MAX_PREVIEW_REQUESTS) {
          var candidate = findPreemptablePreview(entry.index);
          if (candidate) cancelPreview(candidate.index, false);
        }
      }
      pumpPreviewQueue();
    }

    function trimPreviewQueue() {
      while (previewQueue.length > PREVIEW_QUEUE_LIMIT) {
        var candidate = null;
        var fallback = null;
        for (var queueIndex = previewQueue.length - 1; queueIndex >= 0; queueIndex -= 1) {
          if (previewQueue[queueIndex].index === activeIndex) continue;
          if (!fallback) fallback = previewQueue[queueIndex];
          if (previewQueue[queueIndex].priority === 'high') continue;
          candidate = previewQueue[queueIndex];
          break;
        }
        if (!candidate) candidate = fallback;
        if (!candidate) break;
        cancelPreview(candidate.index, false);
      }
    }

    function preloadPreview(index, priority, urgent) {
      if (index < 0 || index >= slides.length) return Promise.resolve(null);
      var source = previewSources[index];
      if (!source) return Promise.resolve(null);
      if (previewCache[index]) {
        touchPreview(index);
        if (priority === 'high') prioritisePreview(previewCache[index], urgent);
        return previewCache[index].promise;
      }

      var entry = {
        index: index,
        source: source,
        preview: null,
        src: source,
        status: 'queued',
        priority: priority === 'high' ? 'high' : 'low',
        promise: null,
        resolve: null,
        settled: false
      };
      entry.promise = new Promise(function (resolve) { entry.resolve = resolve; });
      previewCache[index] = entry;
      touchPreview(index);
      if (entry.priority === 'high') previewQueue.unshift(entry);
      else previewQueue.push(entry);
      trimPreviewQueue();
      if (entry.priority === 'high') prioritisePreview(entry, urgent);
      else pumpPreviewQueue();
      return entry.promise;
    }

    function prunePreviewWork(keepIndices) {
      var keep = new Set(keepIndices);
      previewOrder.slice().forEach(function (index) {
        var entry = previewCache[index];
        if (!entry || (entry.status !== 'queued' && entry.status !== 'loading')) return;
        if (index !== activeIndex && !keep.has(index)) cancelPreview(index, false);
      });
      pumpPreviewQueue();
    }

    function clearPreviewCache() {
      previewCache.forEach(function (entry, index) {
        if (entry) cancelPreview(index, false);
      });
      previewQueue.length = 0;
      previewOrder.length = 0;
      previewInFlight = 0;
    }

    function restoreImage(index, compact) {
      var image = images[index];
      var original = originalImages[index];
      if (!image || !original) return;
      image.setAttribute('sizes', compact ? SIDE_IMAGE_SIZES : original.sizes);
      if (original.srcset) image.setAttribute('srcset', original.srcset);
      else image.removeAttribute('srcset');
      if (original.src) image.setAttribute('src', original.src);
      image.setAttribute('loading', original.loading);
      if (original.fetchpriority) image.setAttribute('fetchpriority', original.fetchpriority);
      else image.removeAttribute('fetchpriority');
      image.removeAttribute('data-archive-promoted');
      image.removeAttribute('data-archive-fallback');
    }

    function suspendImage(index) {
      var image = images[index];
      if (!image) return;
      image.removeAttribute('srcset');
      image.removeAttribute('src');
      image.removeAttribute('sizes');
      image.removeAttribute('data-archive-promoted');
      image.removeAttribute('data-archive-fallback');
    }

    function promoteImage(index, entry, token) {
      if (!verticalMode || destroyed || !entry || entry.status !== 'ready' || token !== imageToken || index !== activeIndex) return;
      var image = images[index];
      if (!image || !entry.src) return;
      image.removeAttribute('srcset');
      image.removeAttribute('src');
      image.setAttribute('src', entry.src);
      image.setAttribute('sizes', ACTIVE_IMAGE_SIZES);
      image.setAttribute('loading', 'eager');
      image.setAttribute('fetchpriority', 'high');
      image.removeAttribute('data-archive-fallback');
      image.setAttribute('data-archive-promoted', '');
    }

    function applyResponsiveImage(index) {
      var image = images[index];
      if (!image) return;
      image.setAttribute('sizes', ACTIVE_IMAGE_SIZES);
      image.setAttribute('loading', 'eager');
      image.setAttribute('fetchpriority', 'high');
      image.setAttribute('data-archive-fallback', '');
    }

    function applyActiveImageFallback(index, token) {
      if (!verticalMode || destroyed || token !== imageToken || index !== activeIndex) return;
      applyResponsiveImage(index);
    }

    function requestActivePreview(index, token, allowRetry) {
      preloadPreview(index, 'high', true).then(function (entry) {
        if (entry) {
          promoteImage(index, entry, token);
          return;
        }
        if (!verticalMode || destroyed || token !== imageToken || index !== activeIndex) return;
        applyActiveImageFallback(index, token);
        if (!allowRetry) return;
        window.clearTimeout(imageRetryTimer);
        imageRetryTimer = window.setTimeout(function () {
          imageRetryTimer = null;
          if (!verticalMode || destroyed || token !== imageToken || index !== activeIndex) return;
          requestActivePreview(index, token, false);
        }, ACTIVE_IMAGE_RETRY_DELAY);
      });
    }

    function activateImage(index) {
      if (!images[index]) return;
      imageToken += 1;
      var token = imageToken;
      window.clearTimeout(imageRetryTimer);
      imageRetryTimer = null;
      var entry = previewCache[index];
      if (entry && entry.status === 'ready') {
        promoteImage(index, entry, token);
        return;
      }
      requestActivePreview(index, token, true);
    }

    function preloadWindow(index, direction) {
      preloadPreview(index + direction, 'high');
      preloadPreview(index - direction, 'auto');
      preloadPreview(index + (direction * 2), 'auto');
    }

    function setImageDeferral(enabled) {
      enabled = !!enabled;
      if (deferImageWork === enabled) return;
      deferImageWork = enabled;
    }

    function commitActiveImage(index, direction) {
      if (committedImageIndex !== index) {
        if (retainedImageIndex >= 0 && retainedImageIndex !== index && images[retainedImageIndex]) {
          restoreImage(retainedImageIndex, true);
        }
        retainedImageIndex = committedImageIndex;
      }
      committedImageIndex = index;
      activateImage(index);
      preloadWindow(index, direction || 1);
    }

    function measureCoverflowMetrics() {
      var viewportWidth = viewport.clientWidth;
      var viewportHeight = viewport.clientHeight;
      var referenceWidth = Math.max(280, Math.min(480, viewportWidth * .32, (viewportHeight - 112) * .66));
      var maxPlaneWidth = Math.min(480, viewportWidth * .32);
      var planeHeight = Math.max(280, Math.min(referenceWidth / .75, maxPlaneWidth / widestImageRatio, viewportHeight - 128));
      var referencePlaneWidth = planeHeight * .67;
      carousel.style.setProperty('--archive-plane-height', planeHeight + 'px');
      coverflowMetrics = {
        planeHeight: planeHeight,
        sideStep: Math.max(38, Math.min(52, referencePlaneWidth * .11))
      };
    }

    function renderCoverflow() {
      if (!coverflowMetrics) measureCoverflowMetrics();
      var planeHeight = coverflowMetrics.planeHeight;
      var sideStep = coverflowMetrics.sideStep;
      var nextRendered = [];
      var lower = Math.floor(flowPosition);
      var upper = Math.ceil(flowPosition);
      var candidateIndex = clampIndex(Math.round(flowPosition));
      var first = Math.max(0, lower - RENDER_RANGE);
      var last = Math.min(slides.length - 1, upper + RENDER_RANGE);

      if (!scrubberDragging) {
        preloadPreview(candidateIndex, 'high', true);
        if (lower !== candidateIndex) preloadPreview(lower, 'high');
        if (upper !== candidateIndex) preloadPreview(upper, 'high');
      }

      renderedIndices.forEach(function (index) {
        if (index < first || index > last) {
          slides[index].classList.remove('is-rendered');
          suspendImage(index);
        }
      });

      for (var index = first; index <= last; index += 1) {
        var slide = slides[index];
        var frame = getArchivePlaneFrame(index, flowPosition, imageRatios, planeHeight, sideStep);
        nextRendered.push(index);
        var wasRendered = slide.classList.contains('is-rendered');
        var imageMissing = images[index] && !images[index].getAttribute('src');
        var shouldRestore = !scrubberDragging || index === lower || index === upper;
        if ((!wasRendered || imageMissing) && shouldRestore) {
          restoreImage(index, scrubberDragging || index !== candidateIndex);
        } else if (!wasRendered && scrubberDragging) suspendImage(index);

        slide.style.setProperty('--archive-x', frame.x + 'px');
        slide.style.setProperty('--archive-y', '0px');
        slide.style.setProperty('--archive-z', frame.z + 'px');
        slide.style.setProperty('--archive-rotate', frame.rotate + 'deg');
        slide.style.setProperty('--archive-scale', frame.scale);
        slide.style.setProperty('--archive-origin', frame.origin + '%');
        slide.style.zIndex = String(frame.zIndex);
        slide.classList.add('is-rendered');
      }
      var renderWindowChanged = nextRendered.length !== renderedIndices.length || nextRendered.some(function (index, position) {
        return renderedIndices[position] !== index;
      });
      if (renderWindowChanged) prunePreviewWork(nextRendered);
      renderedIndices = nextRendered;
      syncScrubber(flowPosition);
    }

    function clearCoverflowStyles() {
      slides.forEach(function (slide) {
        slide.classList.remove('is-rendered');
        slide.removeAttribute('aria-hidden');
        slide.style.removeProperty('--archive-x');
        slide.style.removeProperty('--archive-y');
        slide.style.removeProperty('--archive-z');
        slide.style.removeProperty('--archive-rotate');
        slide.style.removeProperty('--archive-scale');
        slide.style.removeProperty('--archive-origin');
        slide.style.removeProperty('z-index');
      });
      renderedIndices = [];
      coverflowMetrics = null;
      deferImageWork = false;
      retainedImageIndex = -1;
      carousel.removeAttribute('data-archive-direct-navigation');
      carousel.style.removeProperty('--archive-plane-height');
    }

    function clearSelection(index) {
      if (index < 0 || index >= slides.length) return;
      slides[index].classList.remove('is-active', 'is-previous', 'is-next');
    }

    function updateSelection(oldIndex) {
      [oldIndex - 1, oldIndex, oldIndex + 1, activeIndex - 1, activeIndex, activeIndex + 1]
        .forEach(clearSelection);
      slides[activeIndex].classList.add('is-active');
      if (activeIndex > 0) slides[activeIndex - 1].classList.add('is-previous');
      if (activeIndex < slides.length - 1) slides[activeIndex + 1].classList.add('is-next');
    }

    function syncAllState() {
      updating = true;
      cards.forEach(function (card, cardIndex) {
        card.open = cardIndex === activeIndex;
      });
      updating = false;
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === activeIndex);
        slide.classList.toggle('is-previous', slideIndex === activeIndex - 1);
        slide.classList.toggle('is-next', slideIndex === activeIndex + 1);
      });
      summaries.forEach(function (summary, summaryIndex) {
        summary.tabIndex = summaryIndex === activeIndex ? 0 : -1;
        if (summaryIndex === activeIndex) summary.setAttribute('aria-current', 'true');
        else summary.removeAttribute('aria-current');
      });
    }

    function setActive(index, options) {
      options = options || {};
      index = clampIndex(index);
      var oldIndex = activeIndex;
      var changed = index !== oldIndex;
      var transferFocus = changed && slides[oldIndex].contains(document.activeElement);
      var transferMetadataFocus = changed && activeMetadata && activeMetadata.contains(document.activeElement);
      if (!changed && !options.force) {
        if (options.announce) {
          window.clearTimeout(announceTimer);
          announceTimer = null;
          updateStatus(true);
        }
        if (options.focus) summaries[activeIndex].focus({ preventScroll: true });
        return;
      }

      activeIndex = index;
      updating = true;
      if (oldIndex !== activeIndex) cards[oldIndex].open = false;
      cards[activeIndex].open = true;
      updating = false;
      updateSelection(oldIndex);
      if (oldIndex !== activeIndex) {
        summaries[oldIndex].tabIndex = -1;
        summaries[oldIndex].removeAttribute('aria-current');
      }
      summaries[activeIndex].tabIndex = 0;
      summaries[activeIndex].setAttribute('aria-current', 'true');
      updateActiveMetadata(activeIndex);

      if (verticalMode) {
        if (!options.skipRender) renderCoverflow();
        if (!options.transient) commitActiveImage(activeIndex, activeIndex >= oldIndex ? 1 : -1);
      } else applyResponsiveImage(activeIndex);

      updateControls();
      updateMakerLinks();
      if (options.announce) {
        window.clearTimeout(announceTimer);
        announceTimer = null;
        updateStatus(true);
      }
      else if (verticalMode && changed && !options.transient) scheduleAnnouncement();
      if (transferFocus || transferMetadataFocus) summaries[activeIndex].focus({ preventScroll: true });
      else if (options.focus) summaries[activeIndex].focus({ preventScroll: true });
    }

    function measureVertical() {
      scrollStep = Math.round(Math.max(MIN_SCROLL_STEP, Math.min(MAX_SCROLL_STEP, viewport.clientHeight * SCROLL_STEP_RATIO)));
      var runway = Math.max(0, (slides.length - 1) * scrollStep);
      carousel.style.setProperty('--archive-runway', runway + 'px');
      journeyStart = carousel.getBoundingClientRect().top + currentScroll() - headerHeight();
      coverflowMetrics = null;
      renderCoverflow();
      if (lenis && typeof lenis.resize === 'function') lenis.resize();
    }

    function scheduleVerticalSettle() {
      window.clearTimeout(verticalSettleTimer);
      verticalSettleTimer = null;
      if (!verticalMode || !lenis || scrubberDragging) return;
      var scroll = currentScroll();
      var journeyEnd = journeyStart + ((slides.length - 1) * scrollStep);
      if (scroll <= journeyStart + 1 || scroll >= journeyEnd - 1) return;

      verticalSettleTimer = window.setTimeout(function () {
        verticalSettleTimer = null;
        if (!verticalMode || destroyed || !lenis) return;
        var current = currentScroll();
        if (current <= journeyStart + 1 || current >= journeyEnd - 1) return;
        var index = clampIndex(Math.round((current - journeyStart) / scrollStep));
        var target = journeyStart + (index * scrollStep);
        setImageDeferral(false);
        if (Math.abs(current - target) < 1) {
          flowPosition = index;
          renderCoverflow();
          if (index !== activeIndex) setActive(index, { announce: false, skipRender: true });
          else if (committedImageIndex !== index) commitActiveImage(index, index >= committedImageIndex ? 1 : -1);
          return;
        }
        lenis.scrollTo(target, {
          duration: .34,
          easing: archiveEaseOut,
          force: true,
          userData: { source: 'archive-coverflow-settle' },
          onComplete: function () {
            flowPosition = index;
            renderCoverflow();
            if (index !== activeIndex) setActive(index, { announce: false, skipRender: true });
            if (committedImageIndex !== index) commitActiveImage(index, index >= committedImageIndex ? 1 : -1);
          }
        });
      }, VERTICAL_SETTLE_DELAY);
    }

    function onLenisScroll(state) {
      if (!verticalMode || destroyed) return;
      var journeyEnd = journeyStart + ((slides.length - 1) * scrollStep);
      carousel.toggleAttribute(
        'data-archive-scene-active',
        state.scroll >= journeyStart - 1 && state.scroll <= journeyEnd + 1
      );
      var source = state.userData && state.userData.source;
      var programmatic = isArchiveProgrammaticSource(source);
      if (!programmatic) {
        scrubberKeyTarget = null;
        archiveKeyTarget = null;
      }
      if (source === 'archive-coverflow-top') return;
      var frame = getArchiveMotionFrame(
        state.scroll,
        journeyStart,
        scrollStep,
        slides.length,
        activeIndex,
        programmatic ? 0 : state.velocity,
        programmatic ? state.scroll : state.targetScroll,
        FAST_SCROLL_VELOCITY_RATIO,
        FAST_SCROLL_LAG_RATIO
      );
      var wasDeferred = deferImageWork;
      var indexChanged = frame.index !== activeIndex;
      if (!programmatic) setImageDeferral(frame.deferImages);
      flowPosition = frame.position;
      renderCoverflow();
      if (indexChanged) setActive(frame.index, { announce: false, transient: deferImageWork, skipRender: true });
      else if (!programmatic && wasDeferred && !deferImageWork && committedImageIndex !== activeIndex) {
        commitActiveImage(activeIndex, activeIndex >= committedImageIndex ? 1 : -1);
      }
      if (!programmatic) scheduleVerticalSettle();
    }

    function measureHorizontal() {
      horizontalTargets = slides.map(function (slide) {
        return slide.offsetLeft - ((viewport.clientWidth - slide.offsetWidth) / 2);
      });
    }

    function nearestHorizontalIndex() {
      if (!horizontalTargets.length) measureHorizontal();
      var nearest = 0;
      var distance = Infinity;
      horizontalTargets.forEach(function (target, index) {
        var nextDistance = Math.abs(target - viewport.scrollLeft);
        if (nextDistance < distance) {
          nearest = index;
          distance = nextDistance;
        }
      });
      return nearest;
    }

    function settleHorizontal() {
      if (verticalMode || mobileCatalogue.matches || touchCoverflowMode || scrubberDragging) return;
      var index = nearestHorizontalIndex();
      var announce = index !== horizontalHandledIndex;
      horizontalHandledIndex = -1;
      setActive(index, { announce: announce });
    }

    function goTo(index, options) {
      options = options || {};
      if (options.source !== 'archive-coverflow-scrub-keyboard') scrubberKeyTarget = null;
      if (options.source !== 'archive-coverflow-keyboard') archiveKeyTarget = null;
      index = clampIndex(index);
      var jumpDistance = Math.abs(index - activeIndex);
      var direct = verticalMode && !!options.direct;
      var immediate = verticalMode && (direct || !!options.immediate || reducedMotion.matches);
      var atomic = verticalMode && (direct || (immediate && jumpDistance > 1));
      if (direct) carousel.setAttribute('data-archive-direct-navigation', '');
      if (verticalMode && jumpDistance > 1) setImageDeferral(true);
      if (direct && lenis && typeof lenis.reset === 'function') lenis.reset();

      if (touchCoverflowMode) {
        window.clearTimeout(touchSettleTimer);
        touchSettleTimer = null;
        var touchImmediate = direct || !!options.immediate || reducedMotion.matches;
        if (touchImmediate) carousel.removeAttribute('data-archive-touch-settling');
        else {
          carousel.setAttribute('data-archive-touch-settling', '');
          viewport.getBoundingClientRect();
        }
        flowPosition = index;
        renderCoverflow();
        setImageDeferral(false);
        setActive(index, {
          announce: options.announce,
          focus: options.focus,
          force: true,
          skipRender: true
        });
        if (direct) {
          pin.getBoundingClientRect();
          carousel.toggleAttribute('data-archive-direct-navigation', false);
        }
        if (!touchImmediate) {
          touchSettleTimer = window.setTimeout(function () {
            touchSettleTimer = null;
            carousel.removeAttribute('data-archive-touch-settling');
          }, 380);
        }
        return;
      }

      if (verticalMode && lenis) {
        window.clearTimeout(verticalSettleTimer);
        verticalSettleTimer = null;
        if (immediate) {
          flowPosition = index;
          setActive(index, { announce: options.announce, focus: options.focus, force: true });
        }
        lenis.scrollTo(journeyStart + (index * scrollStep), {
          immediate: immediate,
          duration: Math.min(.56, .38 + (jumpDistance * .045)),
          easing: archiveEaseOut,
          force: true,
          userData: { source: options.source || 'archive-coverflow' },
          onComplete: function () {
            if (immediate) return;
            flowPosition = index;
            renderCoverflow();
            setImageDeferral(false);
            setActive(index, {
              announce: options.announce,
              focus: options.focus,
              force: true,
              skipRender: true
            });
          }
        });
        if (atomic) {
          pin.getBoundingClientRect();
          carousel.removeAttribute('data-archive-direct-navigation');
          setImageDeferral(false);
        }
        return;
      }

      if (!horizontalTargets.length) measureHorizontal();
      viewport.scrollTo({
        left: horizontalTargets[index],
        behavior: options.immediate || reducedMotion.matches ? 'auto' : 'smooth'
      });
    }

    function detachLenis() {
      if (unsubscribeLenis) unsubscribeLenis();
      unsubscribeLenis = null;
    }

    function updateMode() {
      detachLenis();
      if (scrubberDragging) setImageDeferral(false);
      if (scrubberPointerId !== null && scrubberInput && scrubberInput.hasPointerCapture && scrubberInput.hasPointerCapture(scrubberPointerId)) {
        try { scrubberInput.releasePointerCapture(scrubberPointerId); } catch (error) {}
      }
      scrubberDragging = false;
      scrubberPointerId = null;
      scrubberKeyTarget = null;
      archiveKeyTarget = null;
      horizontalHandledIndex = -1;
      carousel.removeAttribute('data-archive-scrubbing');
      if (touchPointerId !== null && viewport.hasPointerCapture && viewport.hasPointerCapture(touchPointerId)) {
        try { viewport.releasePointerCapture(touchPointerId); } catch (error) {}
      }
      touchPointerId = null;
      touchGestureIntent = 'idle';
      touchDragging = false;
      touchSuppressClick = false;
      window.clearTimeout(touchSettleTimer);
      touchSettleTimer = null;
      window.clearTimeout(touchClickTimer);
      touchClickTimer = null;
      carousel.classList.remove('is-dragging');
      carousel.removeAttribute('data-archive-touch-coverflow');
      carousel.removeAttribute('data-archive-touch-settling');
      touchCoverflowMode = touchCoverflow.matches && !mobileCatalogue.matches;
      verticalMode = touchCoverflowMode || (!!lenis && desktopMode.matches && !reducedMotion.matches);
      setScrubberAvailability(!mobileCatalogue.matches && slides.length > 1);

      if (mobileCatalogue.matches) {
        verticalMode = false;
        imageToken += 1;
        window.clearTimeout(verticalSettleTimer);
        verticalSettleTimer = null;
        window.clearTimeout(imageRetryTimer);
        imageRetryTimer = null;
        clearPreviewCache();
        carousel.setAttribute('data-archive-mobile-catalogue', '');
        carousel.removeAttribute('aria-roledescription');
        carousel.removeAttribute('data-archive-vertical-mode');
        carousel.removeAttribute('data-archive-scene-active');
        carousel.removeAttribute('data-archive-direct-navigation');
        carousel.style.removeProperty('--archive-runway');
        viewport.removeAttribute('data-lenis-prevent-wheel');
        clearCoverflowStyles();
        images.forEach(function (image, index) {
          if (image) restoreImage(index, false);
        });
        updating = true;
        cards.forEach(function (card) { card.open = false; });
        updating = false;
        slides.forEach(function (slide) {
          slide.removeAttribute('aria-hidden');
          slide.classList.remove('is-active', 'is-previous', 'is-next');
        });
        summaries.forEach(function (summary) {
          summary.tabIndex = 0;
          summary.removeAttribute('aria-current');
        });
        return;
      }

      carousel.removeAttribute('data-archive-mobile-catalogue');
      if (originalRoleDescription) carousel.setAttribute('aria-roledescription', originalRoleDescription);

      if (touchCoverflowMode) {
        imageToken += 1;
        window.clearTimeout(settleTimer);
        settleTimer = null;
        window.clearTimeout(verticalSettleTimer);
        verticalSettleTimer = null;
        window.clearTimeout(imageRetryTimer);
        imageRetryTimer = null;
        clearPreviewCache();
        carousel.setAttribute('data-archive-touch-coverflow', '');
        carousel.setAttribute('data-archive-vertical-mode', '');
        carousel.setAttribute('data-archive-scene-active', '');
        carousel.removeAttribute('data-archive-direct-navigation');
        carousel.style.removeProperty('--archive-runway');
        viewport.removeAttribute('data-lenis-prevent-wheel');
        viewport.scrollLeft = 0;
        clearCoverflowStyles();
        images.forEach(function (image, index) {
          if (!image) return;
          if (index === activeIndex) restoreImage(index, false);
          else suspendImage(index);
        });
        flowPosition = activeIndex;
        syncAllState();
        setActive(activeIndex, { force: true, announce: false, skipRender: true });
        coverflowMetrics = null;
        renderCoverflow();
        return;
      }

      if (verticalMode) {
        flowPosition = activeIndex;
        carousel.setAttribute('data-archive-vertical-mode', '');
        viewport.removeAttribute('data-lenis-prevent-wheel');
        viewport.scrollLeft = 0;
        slides.forEach(function (slide) { slide.removeAttribute('aria-hidden'); });
        images.forEach(function (image, index) {
          if (!image) return;
          if (index === activeIndex) restoreImage(index, false);
          else suspendImage(index);
        });
        syncAllState();
        setActive(activeIndex, { force: true, announce: false });
        measureVertical();
        unsubscribeLenis = lenis.on('scroll', onLenisScroll);
        onLenisScroll(lenis);
      } else {
        imageToken += 1;
        window.clearTimeout(verticalSettleTimer);
        verticalSettleTimer = null;
        window.clearTimeout(imageRetryTimer);
        imageRetryTimer = null;
        clearPreviewCache();
        carousel.removeAttribute('data-archive-vertical-mode');
        carousel.removeAttribute('data-archive-scene-active');
        carousel.removeAttribute('data-archive-direct-navigation');
        if (lenis) viewport.setAttribute('data-lenis-prevent-wheel', '');
        carousel.style.removeProperty('--archive-runway');
        clearCoverflowStyles();
        images.forEach(function (image, index) {
          if (image) restoreImage(index, false);
        });
        slides.forEach(function (slide) { slide.removeAttribute('aria-hidden'); });
        syncAllState();
        setActive(activeIndex, { force: true, announce: false });
        measureHorizontal();
        viewport.scrollLeft = horizontalTargets[activeIndex];
        syncScrubber(activeIndex);
      }
    }

    function archiveKeyboardSceneIsActive() {
      if (!verticalMode || !carousel.hasAttribute('data-archive-scene-active')) return false;
      var rect = pin.getBoundingClientRect();
      return rect.bottom > headerHeight() && rect.top < window.innerHeight;
    }

    function onArchiveKeydown(event) {
      if (
        event.defaultPrevented ||
        event.altKey || event.ctrlKey || event.metaKey || event.shiftKey ||
        mobileCatalogue.matches
      ) return;

      var focusInside = !!(event.target && root.contains(event.target));
      if (!focusInside && !archiveKeyboardSceneIsActive()) return;
      if (
        event.target && event.target.closest &&
        event.target.closest('input, textarea, select, button, a, [contenteditable="true"]')
      ) return;
      if (!focusInside && (event.key === 'Home' || event.key === 'End')) return;

      var currentIndex = archiveKeyTarget === null ? activeIndex : archiveKeyTarget;
      var targetIndex = getArchiveCarouselKeyTarget(currentIndex, event.key, slides.length);
      if (targetIndex === null) return;
      event.preventDefault();
      archiveKeyTarget = targetIndex;
      goTo(targetIndex, {
        focus: focusInside,
        announce: true,
        immediate: event.key === 'Home' || event.key === 'End',
        source: 'archive-coverflow-keyboard'
      });
    }

    function endArchiveKeyboard(event) {
      if (!event || ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) >= 0) {
        archiveKeyTarget = null;
      }
    }

    function onTouchCoverflowTap(event) {
      if (!touchCoverflowMode || event.defaultPrevented || event.detail === 0) return;
      if (touchSuppressClick) {
        touchSuppressClick = false;
        return;
      }
      if (
        event.target && event.target.closest &&
        event.target.closest('a, button, input, textarea, select, summary, [contenteditable="true"]')
      ) return;
      var rect = viewport.getBoundingClientRect();
      var direction = getArchiveTapDirection(event.clientX, rect.left, rect.width);
      if (!direction) return;
      event.preventDefault();
      goTo(activeIndex + direction, {
        announce: true,
        source: 'archive-coverflow-tap'
      });
    }

    function onTouchCoverflowPointerDown(event) {
      archiveKeyTarget = null;
      scrubberKeyTarget = null;
      if (!touchCoverflowMode || !event.isPrimary || event.pointerType === 'mouse') return;
      if (touchPointerId !== null) return;
      window.clearTimeout(touchSettleTimer);
      touchSettleTimer = null;
      window.clearTimeout(touchClickTimer);
      touchClickTimer = null;
      carousel.removeAttribute('data-archive-touch-settling');
      touchSuppressClick = false;
      touchPointerId = event.pointerId;
      touchStartX = event.clientX;
      touchStartY = event.clientY;
      touchStartFlowPosition = flowPosition;
      touchGestureIntent = 'pending';
      touchDragging = false;
      if (viewport.hasPointerCapture && viewport.hasPointerCapture(event.pointerId)) {
        try { viewport.releasePointerCapture(event.pointerId); } catch (error) {}
      }
    }

    function onTouchCoverflowPointerMove(event) {
      if (!touchCoverflowMode || event.pointerId !== touchPointerId) return;
      var deltaX = event.clientX - touchStartX;
      var deltaY = event.clientY - touchStartY;

      if (touchGestureIntent === 'pending') {
        var nextIntent = getArchivePointerIntent(deltaX, deltaY);
        if (nextIntent === 'pending') return;
        touchGestureIntent = nextIntent;
        if (touchGestureIntent === 'vertical') {
          touchPointerId = null;
          touchGestureIntent = 'idle';
          return;
        }
        touchGestureIntent = 'horizontal';
        touchDragging = true;
        carousel.classList.add('is-dragging');
        try { viewport.setPointerCapture(event.pointerId); } catch (error) {}
      }

      if (touchGestureIntent !== 'horizontal') return;
      event.preventDefault();
      var swipeStep = Math.max(180, Math.min(300, viewport.clientWidth * .24));
      flowPosition = Math.max(0, Math.min(touchStartFlowPosition - (deltaX / swipeStep), slides.length - 1));
      renderCoverflow();
      var candidateIndex = Math.round(flowPosition);
      if (candidateIndex !== activeIndex) {
        setActive(candidateIndex, { announce: false, transient: true, skipRender: true });
      }
    }

    function cancelTouchCoverflowGesture(event) {
      if (!event || event.pointerId !== touchPointerId) return;
      if (viewport.hasPointerCapture && viewport.hasPointerCapture(touchPointerId)) {
        try { viewport.releasePointerCapture(touchPointerId); } catch (error) {}
      }
      touchPointerId = null;
      touchGestureIntent = 'idle';
      touchDragging = false;
      carousel.classList.remove('is-dragging');
      flowPosition = activeIndex;
      if (touchCoverflowMode) {
        renderCoverflow();
        setActive(activeIndex, { announce: false, force: true, skipRender: true });
      }
    }

    function finishTouchCoverflowGesture(event) {
      if (!event || event.pointerId !== touchPointerId) return;
      var wasDragging = touchGestureIntent === 'horizontal' && touchDragging;
      var deltaX = event.clientX - touchStartX;
      if (viewport.hasPointerCapture && viewport.hasPointerCapture(touchPointerId)) {
        try { viewport.releasePointerCapture(touchPointerId); } catch (error) {}
      }
      touchPointerId = null;
      touchGestureIntent = 'idle';
      touchDragging = false;
      carousel.classList.remove('is-dragging');
      if (!wasDragging) return;

      var startIndex = Math.round(touchStartFlowPosition);
      var targetIndex = Math.round(flowPosition);
      if (targetIndex === startIndex && Math.abs(deltaX) > 36) {
        targetIndex = clampIndex(startIndex + (deltaX < 0 ? 1 : -1));
      }
      flowPosition = targetIndex;
      touchSuppressClick = true;
      window.clearTimeout(touchClickTimer);
      touchClickTimer = window.setTimeout(function () {
        touchClickTimer = null;
        touchSuppressClick = false;
      }, 420);
      goTo(Math.round(flowPosition), { announce: true });
    }

    slides.forEach(function (slide, index) {
      planes[index].addEventListener('click', function (event) {
        event.preventDefault();
        if (touchCoverflowMode && touchSuppressClick) {
          touchSuppressClick = false;
          return;
        }
        if (mobileCatalogue.matches) {
          if (recordLinks[index]) window.location.assign(recordLinks[index].href);
          return;
        }
        if (index === activeIndex) {
          cards[activeIndex].open = true;
          return;
        }
        goTo(index, { announce: true });
      }, { signal: signal });

      cards[index].addEventListener('toggle', function () {
        if (updating) return;
        if (index === activeIndex && !cards[index].open) cards[index].open = true;
        else if (index !== activeIndex && cards[index].open) cards[index].open = false;
      }, { signal: signal });

      planes[index].addEventListener('pointerenter', function () {
        preloadPreview(index, index === activeIndex ? 'high' : 'auto');
      }, { signal: signal });
      planes[index].addEventListener('pointerdown', function () {
        preloadPreview(index, 'high');
      }, { signal: signal });
      planes[index].addEventListener('focusin', function () {
        preloadPreview(index, 'high');
      }, { signal: signal });
    });

    viewport.addEventListener('pointerdown', onTouchCoverflowPointerDown, { signal: signal });
    viewport.addEventListener('pointermove', onTouchCoverflowPointerMove, { passive: false, signal: signal });
    viewport.addEventListener('pointerup', finishTouchCoverflowGesture, { signal: signal });
    viewport.addEventListener('pointercancel', cancelTouchCoverflowGesture, { signal: signal });
    viewport.addEventListener('click', onTouchCoverflowTap, { signal: signal });

    document.addEventListener('keydown', onArchiveKeydown, { signal: signal });
    document.addEventListener('keyup', endArchiveKeyboard, { signal: signal });
    window.addEventListener('blur', endArchiveKeyboard, { signal: signal });

    if (scrubberInput) {
      scrubberInput.addEventListener('pointerdown', onScrubberPointerDown, { signal: signal });
      scrubberInput.addEventListener('pointermove', onScrubberPointerMove, { passive: false, signal: signal });
      scrubberInput.addEventListener('pointerup', finishScrubberPointer, { signal: signal });
      scrubberInput.addEventListener('pointercancel', finishScrubberPointer, { signal: signal });
      scrubberInput.addEventListener('lostpointercapture', finishScrubberPointer, { signal: signal });
      scrubberInput.addEventListener('input', previewScrubber, { signal: signal });
      scrubberInput.addEventListener('change', settleScrubber, { signal: signal });
      scrubberInput.addEventListener('keydown', onScrubberKeydown, { signal: signal });
      scrubberInput.addEventListener('keyup', endScrubberKeyboard, { signal: signal });
      scrubberInput.addEventListener('blur', endScrubberKeyboard, { signal: signal });
    }

    if (previous) previous.addEventListener('click', function () {
      goTo(activeIndex - 1, { announce: true });
    }, { signal: signal });
    if (next) next.addEventListener('click', function () {
      goTo(activeIndex + 1, { announce: true });
    }, { signal: signal });
    if (topButton) topButton.addEventListener('click', function (event) {
      if (!verticalMode || !lenis || !archiveTitle) return;
      event.preventDefault();
      event.stopPropagation();
      window.clearTimeout(verticalSettleTimer);
      verticalSettleTimer = null;
      carousel.setAttribute('data-archive-direct-navigation', '');
      setImageDeferral(true);
      if (typeof lenis.reset === 'function') lenis.reset();
      flowPosition = 0;
      setActive(0, { announce: false, force: true });
      lenis.scrollTo(0, {
        immediate: true,
        force: true,
        userData: { source: 'archive-coverflow-top' }
      });
      pin.getBoundingClientRect();
      carousel.removeAttribute('data-archive-direct-navigation');
      setImageDeferral(false);
      try { history.replaceState(null, '', window.location.pathname + window.location.search); } catch (error) {}
      archiveTitle.focus({ preventScroll: true });
    }, { signal: signal });

    function activateMakerHash(hash, updateHistory) {
      if (mobileCatalogue.matches) return false;
      var target = hash && hash.charAt(0) === '#' ? document.getElementById(hash.slice(1)) : null;
      if (!target || !root.contains(target) || !target.hasAttribute('data-archive-maker-start')) return false;
      goTo(Number(target.getAttribute('data-archive-index')), {
        immediate: true,
        announce: true,
        direct: true,
        source: 'archive-coverflow-maker'
      });
      if (updateHistory && window.location.hash !== hash) {
        try { history.pushState(null, '', hash); } catch (error) {}
      }
      return true;
    }

    makerLinks.forEach(function (link) {
      var target = document.getElementById((link.getAttribute('href') || '').slice(1));
      var index = target ? Number(target.getAttribute('data-archive-index')) : 0;
      link.addEventListener('pointerdown', function () { preloadPreview(index, 'high'); }, { signal: signal });
      link.addEventListener('focus', function () { preloadPreview(index, 'high'); }, { signal: signal });
      link.addEventListener('click', function (event) {
        if (!activateMakerHash(link.getAttribute('href'), true)) return;
        event.preventDefault();
        event.stopPropagation();
      }, { signal: signal });
    });

    window.addEventListener('hashchange', function () {
      activateMakerHash(window.location.hash, false);
    }, { signal: signal });

    viewport.addEventListener('scroll', function () {
      if (verticalMode || mobileCatalogue.matches || touchCoverflowMode) return;
      syncScrubber(horizontalFlowPosition());
      if (scrubberDragging) return;
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(settleHorizontal, 140);
    }, { passive: true, signal: signal });
    if (supportsScrollEnd) {
      viewport.addEventListener('scrollend', function () {
        window.clearTimeout(settleTimer);
        settleHorizontal();
      }, { signal: signal });
    }

    reducedMotion.addEventListener('change', updateMode, { signal: signal });
    desktopMode.addEventListener('change', updateMode, { signal: signal });
    mobileCatalogue.addEventListener('change', updateMode, { signal: signal });
    touchCoverflow.addEventListener('change', updateMode, { signal: signal });
    window.addEventListener('load', function () {
      if (mobileCatalogue.matches) return;
      if (touchCoverflowMode) {
        coverflowMetrics = null;
        renderCoverflow();
        return;
      }
      if (verticalMode) measureVertical();
      else measureHorizontal();
    }, { signal: signal });
    window.addEventListener('beforeprint', function () {
      images.forEach(function (image, index) {
        if (image) restoreImage(index, false);
      });
    }, { signal: signal });
    window.addEventListener('afterprint', updateMode, { signal: signal });

    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(function () {
        if (mobileCatalogue.matches) return;
        if (touchCoverflowMode) {
          coverflowMetrics = null;
          renderCoverflow();
          return;
        }
        if (verticalMode) measureVertical();
        else measureHorizontal();
      });
      resizeObserver.observe(viewport);
    } else {
      window.addEventListener('resize', function () {
        if (mobileCatalogue.matches) return;
        if (touchCoverflowMode) {
          coverflowMetrics = null;
          renderCoverflow();
          return;
        }
        if (verticalMode) measureVertical();
        else measureHorizontal();
      }, { signal: signal });
    }

    updateMode();
    updateControls();
    updateMakerLinks();
    updateActiveMetadata(activeIndex);
    updateStatus(false);
    carousel.setAttribute('data-archive-ready', '');
    if (window.location.hash) activateMakerHash(window.location.hash, false);

    root._archiveDestroy = function () {
      destroyed = true;
      imageToken += 1;
      if (scrubberPointerId !== null && scrubberInput && scrubberInput.hasPointerCapture && scrubberInput.hasPointerCapture(scrubberPointerId)) {
        try { scrubberInput.releasePointerCapture(scrubberPointerId); } catch (error) {}
      }
      scrubberPointerId = null;
      controller.abort();
      if (unsubscribeLenis) unsubscribeLenis();
      unsubscribeLenis = null;
      window.clearTimeout(settleTimer);
      window.clearTimeout(verticalSettleTimer);
      window.clearTimeout(announceTimer);
      window.clearTimeout(imageRetryTimer);
      window.clearTimeout(touchSettleTimer);
      window.clearTimeout(touchClickTimer);
      touchPointerId = null;
      touchGestureIntent = 'idle';
      touchDragging = false;
      touchSuppressClick = false;
      scrubberDragging = false;
      scrubberKeyTarget = null;
      archiveKeyTarget = null;
      horizontalHandledIndex = -1;
      if (resizeObserver) resizeObserver.disconnect();
      carousel.classList.remove('is-dragging');
      carousel.removeAttribute('data-archive-ready');
      carousel.removeAttribute('data-archive-vertical-mode');
      carousel.removeAttribute('data-archive-scene-active');
      carousel.removeAttribute('data-archive-direct-navigation');
      carousel.removeAttribute('data-archive-mobile-catalogue');
      carousel.removeAttribute('data-archive-touch-coverflow');
      carousel.removeAttribute('data-archive-touch-settling');
      carousel.removeAttribute('data-archive-scrubbing');
      if (scrubber) scrubber.hidden = true;
      if (scrubberInput) {
        scrubberInput.disabled = true;
        scrubberInput.style.removeProperty('--archive-scrub-progress');
      }
      if (originalRoleDescription) carousel.setAttribute('aria-roledescription', originalRoleDescription);
      viewport.removeAttribute('data-lenis-prevent-wheel');
      carousel.style.removeProperty('--archive-runway');
      clearCoverflowStyles();
      images.forEach(function (image, index) {
        if (image) restoreImage(index, false);
      });
      slides.forEach(function (slide) { slide.removeAttribute('aria-hidden'); });
      summaries.forEach(function (summary) {
        summary.tabIndex = 0;
        summary.removeAttribute('aria-current');
      });
      clearPreviewCache();
      root._archiveDestroy = null;
    };
  }

  function initWithin(scope) {
    var root = scope.matches && scope.matches('[data-archive-shell]')
      ? scope
      : scope.querySelector && scope.querySelector('[data-archive-shell]');
    initArchive(root);
  }

  initWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initWithin(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches && event.target.matches('[data-archive-shell]')
      ? event.target
      : event.target.querySelector && event.target.querySelector('[data-archive-shell]');
    if (root && root._archiveDestroy) root._archiveDestroy();
  });
})();
